import Text from '@components/Text';
import { css } from '@emotion/react';
import {
    Fragment, ReactNode, useState, MouseEvent,
} from 'react';

import styles from './styles.module.scss';
import TooltipCloseIcon from './TooltipCloseIcon';

export interface Props {
    children?: ReactNode;
    className?:string;
    top?: number;
    bottom?: number;
    right?: number | string;
    left?: number| string;
    visibleKey: string;
    align?: 'left' | 'right' | 'center';
    shape?: 'fill' | 'line';
    backgroundColor?: string;
    color?: string;
    hideClose?: boolean;
}

function Tooltip({
    children, className, top = 16, right = 20, bottom, left,
    visibleKey, align = 'center', shape = 'fill', backgroundColor, color, hideClose,
}:Props) {
    const fullKey = `tooltip-${visibleKey}`;
    const [isHidden, setIsHidden] = useState<boolean>(typeof window !== 'undefined' && !!localStorage.getItem(fullKey));
    const handleHide = (e: MouseEvent<HTMLOrSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(fullKey, 'true');
        }
        setIsHidden(true);
    };
    if (isHidden) {
        return (<Fragment/>);
    }
    return (
        <div className={`${styles.wrapper} ${className || ''}`}
            style={{
                top, right, bottom, left,
            }} >
            <div className={styles.container}>
                <div className={`${styles.triangleWrapper} ${styles[`align-${align}`]}`}>
                    <div className={`${styles.triangle} ${styles[`shape-${shape}`]}`}
                        style={{ backgroundColor }} />
                </div>
                <div className={`${styles.contents} ${styles[`shape-${shape}`]}`}
                    style={{ backgroundColor }} >
                    <Text fontWeight='bold'
                        size='s'
                        className={`${styles.text} ${styles[`shape-${shape}`]}`}
                        color={color} >
                        {children}
                    </Text>
                    {(!hideClose) && (
                        <TooltipCloseIcon className={styles.close}
                            color={color}
                            onClick={handleHide} />
                    )}
                </div>
                {shape === 'line' && (
                    <div className={`${styles.fix} ${styles[`align-${align}`]}`}/>
                )}
            </div>
        </div>
    );
}

function TooltipWrapper({ children }:{children?:ReactNode}) {
    return (
        <div className={styles.wrapperComponent}>
            {children}
        </div>
    );
}

Tooltip.Wrapper = TooltipWrapper;

export default Tooltip;
